import { lazy } from 'react';
import EmptyLayout from 'layouts/EmptyLayout';

const DashboardPage = lazy(() => import('pages/Funzioni/Produzione/Dashboard'));
const LavorazionePage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/Lavorazione'));
const LavorazionePesoPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/Peso'));
const LavorazioneRisultatiPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/Output'));
const LavorazioneAggiungiInputPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiInput'));
const LavorazioneAggiungiInputItemPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiInputItem'));
const LavorazioneAggiungiOutputPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiOutput'));
const LavorazioneInputScan = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiInputScan'));
const LavorazioneInputRimuoviPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/RimuoviInput'));
const LavorazioneInputPeso = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiInputPeso'));
const LavorazioneAggiungiOutputItemPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiOutputItem'));
const LavorazioneAggiungiOutputItemPesoPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiOutputItemPeso'));
const LavorazioneAggiungiOutputItemTaraPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiOutputItemTara'));
const LavorazioneAggiungiOutputItemLocationPage = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/AggiungiOutputItemLocation'));
const LavorazioneCompletata = lazy(() => import('pages/Funzioni/Produzione/Lavorazioni/Completata'));
const ScansioneLottoPage = lazy(() => import('pages/Funzioni/Produzione/Storico/ScansioneLotto'));
const StoricoPage = lazy(() => import('pages/Funzioni/Produzione/Storico/Storico'));
const ScansioneSpostamentiLottoPage = lazy(() => import('pages/Funzioni/Produzione/Spostamenti/ScansioneLotto'));
const SpostamentiLottoPage = lazy(() => import('pages/Funzioni/Produzione/Spostamenti/Spostamento'));

const mobileRoutes =  [{
    layout: EmptyLayout,
    routes: [{
        // Dashboard degli ordini di produzione
        path: '/funzioni/produzione',
        element: DashboardPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Dashboard"] },
    }, {
        // Scansione lotto spostamenti
        path: '/funzioni/produzione/spostamenti/scansione-lotto',
        element: ScansioneSpostamentiLottoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Spostamenti","Scansione lotto"] },
    }, {
        // Spostamento lotto 
        path: '/funzioni/produzione/spostamenti/:lottoId',
        element: SpostamentiLottoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Spostamenti","Spostamento lotto"] },
    }, {
        // Scansione lotto
        path: '/funzioni/produzione/scansione-lotto',
        element: ScansioneLottoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Scansione lotto"] },
    }, {
        // Storico lotto
        path: '/funzioni/produzione/storico-lotto/:lottoId',
        element: StoricoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Storico lotto"] },
    }, {
        // Dettaglio lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId',
        element: LavorazionePage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione"] },
    }, {
        // Dettaglio lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/aggiungi-input',
        element: LavorazioneAggiungiInputPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Nuovo input"] },
    }, {
        // Aggiunta di un item di input alla lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/aggiungi-item',
        element: LavorazioneAggiungiInputItemPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Nuovo input"] },
    }, {
        // Scansione di un item di input per la lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/scan',
        element: LavorazioneInputScan,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Input","Scansione"] },
    }, {
        // Rimozione di item o input da una lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/input/:inputId/rimuovi',
        element: LavorazioneInputRimuoviPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Input","Rimozione"] },
    }, {
        // Peso di un input
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/input/:inputId/peso',
        element: LavorazioneInputPeso,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Input","Peso"] },
    }, {
        // Inserimento peso/quantità del lotto scansionato
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/peso',
        element: LavorazionePesoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Peso"] },
    }, {
        // Output della lavorazione 
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output',
        element: LavorazioneRisultatiPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Output"] },
    }, {
        // Aggiunta nuovo lotto output alla lavorazione
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output/aggiungi',
        element: LavorazioneAggiungiOutputPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Nuovo output"] },
    }, {
        // Aggiunta di un elemento al lotto output (contenitore)
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output/:outputId/aggiungi-item',
        element: LavorazioneAggiungiOutputItemPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Output","Nuovo item"] },
    }, {
        // Aggiunta della tara di un item nell'output
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output/:outputId/items/:itemId/tara',
        element: LavorazioneAggiungiOutputItemTaraPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione", "Output","Item","Tara"] },
    }, {
        // Aggiunta del peso di un item nell'output
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output/:outputId/items/:itemId/peso',
        element: LavorazioneAggiungiOutputItemPesoPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione", "Output","Item","Peso"] },
    }, {
        // Assegnazione cella all'item di un output
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/output/:outputId/items/:itemId/location',
        element: LavorazioneAggiungiOutputItemLocationPage,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Cella"] },
    }, {
        // Assegnazione cella all'item di un output
        path: '/funzioni/produzione/lavorazioni/:lavorazioneId/completata',
        element: LavorazioneCompletata,
        exact: true,
        analytics: { name: ["Funzioni","Produzione","Lavorazione","Completata"] },
    }]
}]

export default mobileRoutes;